import React, { useState } from 'react';
import KundenstreckeParentForm from './kundenstrecke/KundenstreckeParentForm';
import ContactForm from './ContactForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const PathChoiceForm = (props) => {
    const [selectedPath, setSelectedPath] = useState(null);

    const handlePathSelection = (path) => {
        localStorage.setItem('form', 1); // Force set form to 1
        setSelectedPath(path);
    };

    return (
        <div>
            {selectedPath ? null : (
                <div className="container path-parent-container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="path-text">
                                <h3><b>Super!</b></h3> <br/>
                                <h5 style={{marginBottom: "30px"}}>Du kennst nun deine ungefähre Kreditrate und hast eine grobe Marktübersicht erhalten - jetzt bestimmst du wie es für dich weitergeht!
                                Lass unsere kompetenten Finanzierungsexpert*innen die weiteren Schritte übernehmen oder berechne deine Kreditdetails selbst über unseren Online-Rechner!
                                Erhalte dabei so viel oder wenig Unterstützung wie du möchtest und brauchst.<br /><br /><b>Wie möchtest du weitermachen? </b>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div className="row path-panelbox">
                        <div className="col col-md-6 path-panel">
                            <h4 style={{marginBottom: "20px"}}>Eigenständig Kredit berechnen!</h4>
                            <ul className='choice-list'>
                                <li> Du bist ein Selbermacher? Dann ist unser Online-Rechner genau für dich!</li>
                                <li> Zuverlässige und umfangreiche Berechnung direkt vom Sofa aus - mit genauen Daten von dir!</li>
                                <li> Einfach und unkompliziert die Machbarkeit deines Kredits nach Bankregeln prüfen</li>
                                <li> Vereint die Vorteile einer klassischen Beratung mit dem Komfort der Onlinewelt</li>
                            </ul>
                            <button  className="btn btn-secondary btn-contact choice-buttons" style={{margin:"auto", padding: "10px", height: "auto"}} onClick={() => handlePathSelection('KundenstreckeParentForm')}>
                            JETZT KREDITRECHNER STARTEN!
                            </button>
                        </div>
                        <div className="col col-md-6 path-panel">
                            <h4 style={{marginBottom: "20px"}}>Vertraue auf unsere Beratung! </h4>
                            <ul className='choice-list'>
                                <li>Lehne dich zurück und lass unsere Expert*innen übernehmen</li>
                                <li>Verlasse dich auf unsere Beratung und Betreuung mit über 20 Jahren Expertise</li>
                                <li>Profitiere von etlichen Vorteilen und genauem Marktwissen</li>
                                <li>Spare dabei Zeit und Ressourcen</li>
                            </ul>
                            <button  className="btn btn-secondary btn-showmore choice-buttons" style={{margin:"auto", padding: "10px", height: "auto"}} onClick={() => handlePathSelection('contact')}>
                            JETZT UNVERBINDLICH BERATUNG ANFRAGEN!
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {selectedPath === 'KundenstreckeParentForm' && <KundenstreckeParentForm />}
            {selectedPath === 'contact' && <ContactForm product={props.product} onBackClick={props.onBackClick}/>}
        </div>
    );
};

export default PathChoiceForm;